import AccountInvestmentsTable from "./AccountInvestmentsTable"

export default AccountInvestmentsTable
